import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

export default function ScrollToTop() {
  const { pathname } = useLocation();
  const isInitialMount = useRef(true);
  const lastPathname = useRef(pathname);

  useEffect(() => {
    // Skip scroll on initial mount
    if (isInitialMount.current) {
      isInitialMount.current = false;
      lastPathname.current = pathname;
      return;
    }

    // Check if this is a back/forward navigation by looking at performance navigation type
    const navigationType =
      window.performance.getEntriesByType("navigation")[0]?.type;
    const isBackForward = navigationType === "back_forward";

    // Also check if the pathname actually changed (to avoid unnecessary scrolls)
    const pathChanged = pathname !== lastPathname.current;

    if (pathChanged && !isBackForward) {
      // Smooth scroll to top for new navigation
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: "smooth",
      });
    }

    lastPathname.current = pathname;
  }, [pathname]);

  return null;
}
